// extracted by mini-css-extract-plugin
export var container = "styles-module--container--4f40a";
export var light = "styles-module--light--46fbe";
export var outline = "styles-module--outline--d7086";